import { useEffect, useState } from "react";
export function useIsDesktop(breakpoint = 1200) {
  const getMatch = () =>
    typeof window !== "undefined" &&
    window.matchMedia(`(min-width: ${breakpoint + 1}px)`).matches;
  const [isDesktop, setIsDesktop] = useState(getMatch);
  useEffect(() => {
    if (typeof window === "undefined") return;
    const mediaQuery = window.matchMedia(
      `(min-width: ${breakpoint + 1}px)`
    );
    const handler = (event: MediaQueryListEvent) => {
      setIsDesktop(event.matches);
    };
    // Keep state in sync on mount + breakpoint changes
    setIsDesktop(mediaQuery.matches);
    mediaQuery.addEventListener("change", handler);
    return () => mediaQuery.removeEventListener("change", handler);
  }, [breakpoint]);
  return isDesktop;
}
